import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w100 mb20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fl w30 pad10" }
const _hoisted_4 = { class: "fw600 pad10" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, " Googleスプレッドシート連携を行い、入力されたフォーム内容を連携することが可能です。 ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "fl w60 mt30" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "連携を有効にするには、担当者にお問い合わせください。", -1)
const _hoisted_10 = {
  key: 1,
  class: "w100"
}
const _hoisted_11 = { class: "fw600 pad10" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, " Googleスプレッドシート連携を行い、入力されたフォーム内容を連携することが可能です。 ", -1)
const _hoisted_14 = {
  key: 0,
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_15 = {
  class: "fl",
  style: {"width":"280px"}
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "fl fs14" }, "連携済み", -1)
const _hoisted_18 = {
  class: "w100",
  style: {}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.rm.canUseOption(`management_google_spread_sheet`, false))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/logo/google_spread.png`),
                width: "20",
                height: "28",
                class: "pointer fl mr10",
                style: {"margin-top":"-8px"}
              }, null, 8, _hoisted_5),
              _createTextVNode("Googleスプレッドシート連携 ")
            ]),
            _hoisted_6,
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("button", {
              type: "submit",
              class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
              style: {"height":"50px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestGoogleSpreadSheet && _ctx.requestGoogleSpreadSheet(...args)))
            }, " リクエスト ")
          ])
        ]))
      : (_ctx.notiDic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(`fl  pad10 ${_ctx.scope == `room_setting` ? `w100` : `w30`}`)
            }, [
              _createElementVNode("h5", _hoisted_11, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/logo/google_spread.png`),
                  width: "20",
                  height: "28",
                  class: "pointer fl mr10",
                  style: {"margin-top":"-8px"}
                }, null, 8, _hoisted_12),
                _createTextVNode("Googleスプレッドシート連携 ")
              ]),
              _hoisted_13
            ], 2),
            (_ctx.scope == `user`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      (_ctx.notiDic.id == `new`)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "submit",
                            class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                            style: {"height":"50px"},
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goGoogleSpreadSheetOAuth && _ctx.goGoogleSpreadSheetOAuth(...args)))
                          }, " OAuth連携 "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("button", {
                              type: "submit",
                              class: "fl pointer centered circle_button with_white_bg fs14 rad8 mt15 alertRed noborder underline mr20",
                              style: {"height":"50px"},
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeGoogleSpreadSheet && _ctx.removeGoogleSpreadSheet(...args)))
                            }, " 連携解除 ")
                          ]))
                    ])
                  ])
                ]))
              : (_ctx.scope == `room_setting`)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(`fl ${_ctx.scope == `room_setting` ? `w100 pad20` : `w60`}`)
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", null, [
                        (_ctx.notiDic.id == `new`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              (!_ctx.connectableNotis)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "submit",
                                    class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                                    style: {"height":"50px"},
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.connectGoogleSpreadSheet && _ctx.connectGoogleSpreadSheet(...args)))
                                  }, " 公開ページに紐付ける "))
                                : (_ctx.connectableNotis)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      _createElementVNode("button", {
                                        type: "submit",
                                        class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20 padw10 fw600",
                                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectGoogleSpreadSheetFile && _ctx.selectGoogleSpreadSheetFile(...args)))
                                      }, " 詳細を設定 ")
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  type: "submit",
                                  class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt5 mr20 padw10 fw600",
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectGoogleSpreadSheetFile && _ctx.selectGoogleSpreadSheetFile(...args)))
                                }, " 詳細を設定 ")
                              ]),
                              _createElementVNode("button", {
                                type: "submit",
                                class: "fl pointer centered circle_button with_white_bg fs14 rad8 alertRed noborder underline",
                                style: {"height":"50px"},
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.disconnectGoogleSpreadSheet && _ctx.disconnectGoogleSpreadSheet(...args)))
                              }, " 解除 "),
                              _hoisted_22
                            ]))
                      ])
                    ])
                  ], 2))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    _hoisted_23
  ]))
}